import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router';
import type Transition from '@ember/routing/transition';

export default class AuthenticatedTasApplicationsTypeTwoNewRoute extends Route {
  @service declare router: RouterService;

  // Declared so the `date` deep-link param is still recognised on the way through.
  queryParams = {
    date: {
      refreshModel: false,
    },
  };

  // Legacy flow retired — force everyone onto the guided wizard.
  beforeModel(transition: Transition) {
    const id = transition.to?.params?.['tas_application_id'];
    if (!id) return;
    const date = transition.to?.queryParams?.['date'];
    return this.router.replaceWith('authenticated.tas.applications.type-two-guided.new', id, {
      queryParams: date ? { date } : {},
    });
  }
}
